import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import './assets/styles/components.scss';
import { Route, Routes, useLocation } from 'react-router';
import SwimmingPoolPage from './pages/swimming-pool/main';
import PlaygroundPage from './pages/playground/main';
import { FrontLayerProvider } from './context/FrontLayerContext';
import { ToastProvider } from './context/ToastContext';
import DatePicker from './components/common/DatePicker';
import TicketBookingPage from './pages/swimming-pool/booking';
import CouponPage from './pages/swimming-pool/coupon';
import LuckySpinPage from './pages/swimming-pool/lucky-spin';
import TicketPage from './pages/swimming-pool/ticket';
import TicketCancel from './pages/swimming-pool/ticket-cancel';
import EventDetails from './pages/swimming-pool/event-details';
import PrizeWinner from './pages/swimming-pool/prizewinner';
import YaongconPage from './pages/yaongcon/main';
import MyPage from './pages/my-page/main';
import ToryGamePage from './pages/playground/tory-game';
import ToryGameEnd from './pages/playground/tory-game-end';
import { AuthContextProvider } from './context/AuthContext';
import LoginPage from './pages/login';
import NotificationsPage from './pages/playground/notification';
import ItemStore from './pages/playground/item-store';
import RewardDetailPage from './pages/playground/reward-detail';
import CouponDetailPage from './pages/yaongcon/coupon-detail';
import MyPointsPage from './pages/my-page/my-points';
import MyVictoriesPage from './pages/my-page/my-victories';
import SettingsPage from './pages/my-page/settings';
import PolicyPage, { AgreementDetail } from './pages/my-page/policy';
import DeleteAccountPage from './pages/my-page/delete-account';
import OAuth from './pages/OAuth';
import KakaoCallback from './pages/kakao-callback';
import GotoAppStore from './pages/goto-appstore';
import ActionAdDetail from './pages/offerwall/action-ad-detail';
import { lazy, Suspense, useRef } from 'react';
import SummonerAddPage from './pages/my-page/summoner';
import OfferwallPage from './pages/offerwall/main';
import AttendancePage from './pages/playground/attendance';
import RandomLuckPage from './pages/playground/random-luck';
import CatLuckySpin from './pages/playground/cat-lucky-spin';
import InviteFriendsPage from './pages/my-page/invite-friends';
import DesktopPcOnlyPage from './pages/desktop-pc-only';
import DeviceCheck from './components/DevicesCheck';
import YaongSnak from './pages/game/yaong-egg/snack';
import { UnityGameProviderEgg } from './pages/game/yaong-egg/GameProviderEgg';
import Verification from './pages/verification';
import { isDevelopmentMode } from './utils/hooks';
import PlaygroundV2Page from './pages/playground-v2/main-v2';
import PunchPage from './pages/punch';
import PunchPrizeMissionPage from './pages/punch/prize-mission';
import PunchRankingPage from './pages/punch/ranking';
import TimeNyangPage from './pages/time-nyang';
import MulnyangBulnyangPage from './pages/mulnyang-bulnyang/main';

function App() {
  const location = useLocation();
  const lastViewedSlide = useRef();
  const allowWebLuckySpinInDev = isDevelopmentMode();

  return (
    <ErrorBoundary>
      <AuthContextProvider>
        <ToastProvider>
          <FrontLayerProvider>
            <DeviceCheck>
              <UnityGameProviderEgg>
                <Layout>
                  <Routes>
                    {/* PC 전용 리다이렉트 페이지 */}
                    <Route path="/desktop-only" element={<DesktopPcOnlyPage />} />
                    {/* App 내부 화면 */}
                    <Route path={'/'} element={<LoginPage />} />
                    <Route path={'/login'} element={<LoginPage />} />
                    <Route path={'/playground'} element={<PlaygroundV2Page />} />
                    <Route path={'/offerwall'} element={<OfferwallPage />} />
                    <Route path={'/attendance-check'} element={<AttendancePage />} />
                    <Route path={'/random-luck'} element={<RandomLuckPage />} />
                    <Route path={'/punch'} element={<PunchPage />} />
                    <Route path={'/time-nyang'} element={<TimeNyangPage />} />
                    <Route path={'/mulnyang-bulnyang'} element={<MulnyangBulnyangPage />} />
                    <Route path={'/punch/prize-mission'} element={<PunchPrizeMissionPage />} />
                    <Route path={'/punch/ranking'} element={<PunchRankingPage />} />
                    <Route path={'/cat-lucky-spin'} element={<CatLuckySpin />} />
                    <Route path={'/invite'} element={<InviteFriendsPage />} />
                    <Route path={'/notifications'} element={<NotificationsPage />} />
                    <Route path={'/playground-v2/store'} element={<ItemStore />} />
                    <Route path={'/playground-v2/reward'} element={<RewardDetailPage />} />
                    <Route path={'/tory-game'} element={<ToryGamePage />} />
                    <Route path={'/tory-game-end'} element={<ToryGameEnd />} />
                    <Route path={'/pool'} element={<SwimmingPoolPage lastViewedSlide={lastViewedSlide} />} />
                    <Route path={'/pool/booking'} element={<TicketBookingPage />} />
                    <Route path={'/pool/coupon'} element={<CouponPage />} />
                    <Route path={'/pool/booking/success'} element={<LuckySpinPage isAfterBooking={true} />} />
                    <Route path={'/pool/lucky-spin'} element={<LuckySpinPage isAfterBooking={false} />} />
                    <Route path={'/pool/ticket'} element={<TicketPage />} />
                    <Route path={'/pool/ticket/cancel'} element={<TicketCancel />} />
                    <Route path={'/pool/event-details'} element={<EventDetails />} />
                    <Route path={'/pool/prizewinner'} element={<PrizeWinner />} />
                    <Route path={'/coupons'} element={<YaongconPage />} />
                    <Route path={'/coupons/detail'} element={<CouponDetailPage />} />
                    <Route path={'/user'} element={<MyPage />} />
                    <Route path={'/user/points'} element={<MyPointsPage />} />
                    <Route path={'/user/coupons'} element={<CouponPage myPage={true} />} />
                    <Route path={'/user/coupons/detail'} element={<CouponDetailPage />} />
                    <Route path={'/user/victories'} element={<MyVictoriesPage />} />
                    <Route path={'/user/summoner'} element={<SummonerAddPage />} />
                    <Route path={'/user/settings'} element={<SettingsPage />} />
                    <Route path={'/user/policy'} element={<PolicyPage />} />
                    <Route path={'/user/policy/terms-of-use'} element={<AgreementDetail type={'service'} />} />
                    <Route path={'/user/policy/collection-and-use'} element={<AgreementDetail type={'collection'} />} />
                    <Route path={'/user/policy/processing'} element={<AgreementDetail type={'processing'} />} />
                    <Route path={'/user/delete'} element={<DeleteAccountPage />} />
                    <Route path={'/oauth'} element={<OAuth />} />
                    <Route path={'/kakaolink/callback'} element={<KakaoCallback />} />
                    <Route path={'/download'} element={<GotoAppStore />} />
                    <Route path={'/offerwall/action-ad-detail'} element={<ActionAdDetail />} />
                    <Route path={'/game/yaong-egg/snack'} element={<YaongSnak />} />
                    <Route path={'/verification'} element={<Verification />} />
                    <Route path={'/playground-v2'} element={<PlaygroundPage />} />
                  </Routes>
                </Layout>
                {['/pool', '/pool/booking'].includes(location.pathname) && <DatePicker />}
              </UnityGameProviderEgg>
            </DeviceCheck>
          </FrontLayerProvider>
        </ToastProvider>
      </AuthContextProvider>
    </ErrorBoundary>
  );
}

export default App;
